import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import animateScrollTo from 'animated-scroll-to';
import { getNavbarHeight } from '../../../models/Utils';

import NextStory from '../../Common/NextStory/NextStory';
import ExhibitMenu from '../../Common/ExhibitMenu/ExhibitMenu';
import { getViewportDimensions } from '../../../models/Utils';
import {
  setHasVisitedVBN
} from '../../../store/reducers/mainReducer';

import IntroBars from '../subcomponents/IntroBars/IntroBars';

import { ADALandmarks } from '../../../models/ADA';
import './VbnIntro.scss';

const VbnIntro = props => {
  const dispatch = useDispatch();
  const initialized = useSelector(state => state.data.initialized);
  const cmsData = useSelector(state => state.data.cms.verizonByTheNumbers);
  const navbar = useSelector(state => state.data.menus.verizonByTheNumbers);
  const cmsMediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const [creditsActive, setCreditsActive] = useState(false);
  const creditsElement = useRef(null);
  let [ada, setADA] = useState("");

  useEffect(() => {
    document.title = "The Verizon Story - Verizon by the Numbers";
    setTimeout(() => {
      dispatch(setHasVisitedVBN(true));
      setADANonRepeating(cmsData.Introduction.AltText);
    }, 100);
  }, []);

  useEffect(() => {

  }, [ada]);

  const handleScroll = () => {
    if(creditsElement && creditsElement.current){
      const sliderRect = creditsElement.current.getBoundingClientRect();
      const windowHeight = getViewportDimensions().height;
      if ((sliderRect.y <= windowHeight)) {
        setCreditsActive(true);
      }
      else if ((sliderRect.y > windowHeight)) {
        setCreditsActive(false);
      }
    }
  };

  useLayoutEffect(() => {
    handleScroll();

    document.body.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    return () => {
      document.body.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  if(!initialized){
    return null;
  }

  const getBoxes = () => {
    let boxes = [];
    cmsData.Sections.forEach((section) => {
      boxes.push({
        Header: section.Name,
        Body: section.IntroBox.BodyText,
        LearnMore: {
          HasLink: true,
          Text: section.IntroBox.LearnMoreText,
          altText: section.IntroBox.LearnMoreAltText,
          Type: '1',
          InternalURL: {
            BasePath: {
              Text: cmsData.Path.Text,
            },
            Path: {
              Path: section.Menu.Path,
              Text: ''
            }
          },
          ExternalURL: {}
        },
      });
    });
    return boxes;
  };

  function setADANonRepeating(text) {
    if (ada == text) return;
    console.log("[VBN] Set ADA: ", ada)
    setADA(text);
  }

  return (
    
    <div className="vbn-home" role={ADALandmarks.Main}>
      {/* <div className="ada-hidden" aria-hidden={true}>{ada}</div> */}
      <ExhibitMenu title={cmsData ? cmsData.Introduction.Title : ""} links={navbar}/>
      <IntroBars
        data={{
          Header: cmsData.Introduction.Title,
          Body: cmsData.Introduction.Body,
          Boxes: getBoxes()
        }}
      />
      {/*<div style={{ height: `${getViewportDimensions().height}px`, width: "100%", background: "green" }}></div>*/}
      {/*<div ref={creditsElement}>
              <NextStory 
                showNext={creditsActive}
                showCredits={creditsActive}
                next={`/${cmsData.Path.Text}/${cmsData.Sections[0].Menu.Path}`}
                title={`Up next: ${cmsData.Sections[0].Name}`}
                subtitle={cmsData.Sections[0].InitialVideo.Header}
                onCreditsClick={() => {}}
                />
            </div>*/}
    </div>
  );
};

export default VbnIntro;
